module.exports = __webpack_public_path__ + "static/p15-83ada32499e391a20cba302b8e1ee4eb.jpg";